import type { SVGProps } from 'react'
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg 
    width={props.width ? props.width : '8'}
    height={props?.height ? props?.height : '2'}
    viewBox="0 0 8 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.08333 2C0.918056 2 0.779514 1.90417 0.667708 1.7125C0.555903 1.52083 0.5 1.28333 0.5 1C0.5 0.716667 0.555903 0.479167 0.667708 0.2875C0.779514 0.0958333 0.918056 0 1.08333 0H6.91667C7.08194 0 7.22049 0.0958333 7.33229 0.2875C7.4441 0.479167 7.5 0.716667 7.5 1C7.5 1.28333 7.4441 1.52083 7.33229 1.7125C7.22049 1.90417 7.08194 2 6.91667 2H1.08333Z"
      fill={props.fill ? props.fill : 'white'}
    />
  </svg>
)
export default SvgMinus
